import React from 'react'

const Footer = () => {
    return (
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingTop: '12px', paddingRight: '12px', fontSize: '12px'}}>
            <p>COPYRIGHT © 2021</p>
            <p>By MOHAMMED NAJJAR</p>
        </div>
    )
}

export default Footer
